var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813",
    transform: "translate(-1176 -45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_20X20_photo_Back",
    "data-name": "20X20 photo Back",
    transform: "translate(1176 45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_255",
    "data-name": "Mask Group 255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_08.whatsapp",
    "data-name": "08.whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M16.422,19.658a60.517,60.517,0,0,1-12.84,0A3.644,3.644,0,0,1,.341,16.422a60.517,60.517,0,0,1,0-12.84A3.644,3.644,0,0,1,3.577.341a60.518,60.518,0,0,1,12.84,0,3.644,3.644,0,0,1,3.241,3.236,60.517,60.517,0,0,1,0,12.84,3.644,3.644,0,0,1-3.236,3.241Z",
    fill: "#29a71a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20963",
    "data-name": "Path 20963",
    d: "M14.408,5.591a6.2,6.2,0,0,0-9.933,7.173l-.658,3.194a.236.236,0,0,0,.037.185.24.24,0,0,0,.255.1l3.13-.742a6.2,6.2,0,0,0,7.169-9.91Zm-.976,7.79a4.857,4.857,0,0,1-5.593.909L7.4,14.074l-1.919.455.006-.024.4-1.932-.214-.422a4.854,4.854,0,0,1,7.759-5.635.259.259,0,0,0,.025.025A4.854,4.854,0,0,1,13.432,13.381Z",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_20966",
    "data-name": "Path 20966",
    d: "M1.272-.489H3.49c1.4,0,2.268-.723,2.268-1.877A1.59,1.59,0,0,0,4.212-3.951v-.036A1.446,1.446,0,0,0,5.444-5.41c0-1-.773-1.636-2-1.636H1.272a.641.641,0,0,0-.686.713v5.126A.642.642,0,0,0,1.272-.489Zm.686-3.831v-1.7H3.085c.641,0,1.009.3,1.009.827,0,.554-.418.877-1.15.877Zm0,2.808v-1.9h1.15c.809,0,1.25.327,1.25.941s-.427.963-1.218.963Z",
    transform: "translate(1183 58.768)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.fd41d0a2b2da84e4096f3deee7366022.svg";
export { ForwardRef as ReactComponent };